/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
import { writable, derived, get } from 'svelte/store';

import { getResults, RESULTS_PER_PAGE } from '../../../modules/searchanise.js';
import Product from '../../../models/Product.js';
import dispatchEvent from '../../../utils/dispatch-event.js';
import { setAvailableFacets } from './facet-store.js';
import { updateMaxPrice, updateMaxMaxPrice } from './facet-price.js';
import { setPages } from './search-pages.store.js';

export const isLoading = writable(true);
export const collectionProducts = writable([]);
export const searchResponse = writable([]);
export const productCount = derived(
  searchResponse,
  $searchResponse => $searchResponse.totalItems || 0
);
export const currentPage = writable(1);
export const totalPages = derived(
  searchResponse,
  $searchResponse =>
    Math.ceil($searchResponse.totalItems / RESULTS_PER_PAGE) || 1
);

let firstLoad = true;

export async function getProducts(
  page = 1,
  collection,
  appliedFacets,
  currentSort,
  priceFacet,
  query
) {
  isLoading.update(value => (value = true));

  return getResults({
    collection: collection?.handle || null,
    q: query,
    startIndex: (page - 1) * RESULTS_PER_PAGE,
    sortBy: currentSort.sortBy || 'relevance',
    sortOrder: currentSort.sortOrder || 'desc',
    ...appliedFacets,
    ...priceFacet,
  }).then(data => {
    // Check if it is the first load of the page...
    if (firstLoad) {
      // If so, check if the Searchanise data contains facets...
      if (data?.facets?.length > 0) {
        // If so, try and get the Price facet.
        const dataPriceFacet = data.facets.filter(
          facet => facet.title === 'Price'
        )[0];

        // Check if the price facet contain any buckets...
        if (dataPriceFacet?.buckets?.length > 0) {
          // If so, get the first bucket.
          const bucket = dataPriceFacet.buckets[0];

          // Check if a "to" value exists in the bucket...
          if (bucket?.to) {
            // If so, update the maximum values with the "to" value.
            const to = Math.ceil(Number(bucket.to));

            updateMaxPrice(to);
            updateMaxMaxPrice(to);
          }
        }
      }
    }

    searchResponse.set(data);

    let currentProducts = [];

    if (page > 1) {
      currentProducts = get(collectionProducts);
    }

    collectionProducts.set([
      ...new Set([
        ...currentProducts,
        ...data.items.map(product => Product.fromSearchanise(product)),
      ]),
    ]);

    isLoading.update(value => (value = false));
    firstLoad = false;

    dispatchEvent('searchanise:products-loaded', document);

    return data;
  });
}

export async function getFacets(collection, query) {
  isLoading.update(value => (value = true));

  return getResults({
    collection: collection?.handle || null,
    q: query,
  }).then(data => {
    const { facets } = data;

    setAvailableFacets(facets);

    return data;
  });
}

export async function getPages(query) {
  isLoading.update(value => (value = true));

  return getResults({
    q: query,
  }).then(data => {
    const { pages } = data;

    // Filter out any pages that are not a blog.
    const articles = pages.filter(page => !page.link.includes('page'));
    setPages(articles);

    return data;
  });
}
